import { default as MuiSkeleton, SkeletonProps } from '@mui/material/Skeleton'
import * as React from 'react'

type SkeletonRef = HTMLElementTagNameMap['span']

export const Skeleton = React.forwardRef<SkeletonRef, SkeletonProps>(function Skeleton(props, ref) {
  return <MuiSkeleton {...props} ref={ref} />
})

export default Skeleton
